import { Fragment, useRef, useState } from "react"
import { Button, Col, Row } from "react-bootstrap";
import { FileEarmarkPlus, FileEarmarkPlusFill, FilePlus, FilePlusFill, Printer, Search } from "react-bootstrap-icons";
import DatePicker from "react-datepicker2";
import BihamtaTable from "../../../Components/BihamtaTable";
import { searchCustomerInvoices } from "../../../Sale/store/api/Invoice";
import { useHistory } from "react-router-dom";

const CustomerInvoices = (props) => {
    const { customerID } = props;
    const history = useHistory();
    const dateFilters = useRef({});
    const [dataList, setDataList] = useState(null);
    function rowClick(item) {
        window.open(`/Sale/Invoice/${item.InvoiceType_}/${item.InvoiceID}/${item.IsFormal}`);
    }
    function gotoNewInvoice(isFormal)
    {
        window.open(`/Sale/Invoice/Sale/0/${isFormal}`);
    }
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", justInMobile: true },
        { colTitle: "نوع فاکتور", colName: "InvoiceType", justInMobile: true },
        { colTitle: "شماره فاکتور", colName: "InvoiceNumber", justInMobile: false },
        { colTitle: "تاریخ فاکتور", colName: "PContactDate", justInMobile: true },
        { colTitle: "وضعیت", colName: "PInvoiceState", justInMobile: false },
        { colTitle: "رسمی", colName: "IsFormal", justInMobile: false, colType: "boolean" },
        { colTitle: "جمع فاکتور", colName: "InvoiceTotalPrice", colType: "currency" },
        { colTitle: "تخفیف", colName: "Discount", colType: "currency" },
        { colTitle: "مالیات", colName: "TaxFee", colType: "currency" },
        { colTitle: "سایر هزینه ها", colName: "FreightCharge", colType: "currency" },
        { colTitle: "قابل پرداخت", colName: "InvoicePureTotalPrice", colType: "currency" },
        { colTitle: "ثبت کننده", colName: "CreateByName", justInMobile: false },
        { colTitle: "تاریخ ثبت", colName: "PCreationDate", justInMobile: false },
        { colTitle: "توضیحات", colName: "Description", justInMobile: false, colType: "string", maxTextLength: 100 },
    ]   
    function search(){
        const data={
            CustomerID: customerID,
            CustomerCat:3
        }
        const pDateFrom = document.getElementsByName("ContactDateFrom")[0].value;
        if(pDateFrom !=="")
        {
            data.ContactDateFrom = dateFilters.current.ContactDateFrom;
        }
        const pDateTo = document.getElementsByName("ContactDateTo")[0].value;
        if(pDateTo !=="")
        {
            data.ContactDateTo = dateFilters.current.ContactDateTo;
        } 
        setDataList("PENDING");
        searchCustomerInvoices(data, setDataList)       ;
    } 
    function printInvoice(item) {
        const reportName = (item.IsFormal ? "Formal" : "") + item.InvoiceType_ + "Invoice";
        history.push({
            pathname: `/PrintViewer/${reportName}/false`,
            state: {
                dataUrl: `api/InvoiceAPI/GetInvoice?invoiceType=${item.InvoiceType_}&invoiceID=${item.InvoiceID}`,
                method: "get"
            }
        });
    }
    const tableRowButtons = [
        {
            title: "چاپ فاکتور", type: "common", className: "group-Btn-smalll btn-primary", onclick: printInvoice, icon: <Printer color="#2727ff" size={18} className="rowBtn" />
        }

    ]        
    return (
        <Fragment>
            <Row className="rowBorder mb-2">
                <Col md={2} className="form-group">
                    <label>تاریخ فاکتور از:</label>
                    <DatePicker isGregorian={false} timePicker={false} className="form-control" name="ContactDateFrom"
                        onChange={value => dateFilters.current.ContactDateFrom = value.local("en").format("YYYY-MM-DD")} />
                </Col>
                <Col md={2} className="form-group">
                    <label>تاریخ فاکتور تا:</label>
                    <DatePicker isGregorian={false} timePicker={false} className="form-control" name="ContactDateTo"
                        onChange={val => dateFilters.current.ContactDateTo = val.local("en").format("YYYY-MM-DD")} />
                </Col>
                <Col md={4} className="form-group" style={{ display: "flex", alignItems: "flex-end" }}>
                    <Button className="group-Btn-large" onClick={search}><Search size={17} />&nbsp;جستجوی فاکتور</Button>
                    <Button className="group-Btn-large" variant="secondary" onClick={()=>gotoNewInvoice(false)}><FileEarmarkPlus size={18} />&nbsp;ثبت فاکتور</Button>
                    <Button className="group-Btn-large" variant="info" onClick={()=>gotoNewInvoice(true)}><FileEarmarkPlusFill size={18} />&nbsp;ثبت فاکتور رسمی</Button>
                </Col>                               
            </Row>
            <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} rowClick={rowClick} dataList={dataList}  fixedHeight className="mt-0"/>
        </Fragment>
    )
}
export default CustomerInvoices